export * from './use-link-school';
